import React from "react";
import { makeStyles, Button as MaterialButton } from "@material-ui/core";

export default function Button(props) {
  const { onClick, children, className: classNameProps } = props;
  const classes = useStyles({ ...props })();
  return (
    <MaterialButton
      {...props}
      onClick={onClick}
      fullWidth
      className={`${classes.btn} ${classNameProps}`}
    >
      {children}
    </MaterialButton>
  );
}

const useStyles = ({ ...props }) =>
  makeStyles((theme) => ({
    btn: {
      backgroundColor: theme.palette.secondary.main,
      color: "#FFF",
      height: 41,
      borderRadius: 20.5,
      fontSize: "1.125rem",
      lineHeight: "1.375rem",
      fontWeight: "bold",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
      },
    },
  }));
